import axios from "axios";

import {
  BASE_URL,
  SHOP,
  RELATED_URL,
  CORE_SERVICE_URL,
  BASE_URL_NEW,
} from "../config/config";
const urlParams = "by-passs";
const apiService = {
  get: (action, params = {}) => {
    return axios.get(BASE_URL, {
      params: {
        action,
        ...params,
        shop: window.dynamicReview ? window.shopPreview : SHOP,
      },
    });
  },

  getTrackingPageMutation: (params = {}) => {
    return axios.get(BASE_URL_NEW + "/tracking-store/search", {
      params: {
        ...params,
        shop: params.shop || SHOP,
        urlParams,
      },
    });
  },

  getRelated: (action, params = {}) => {
    return axios.get(BASE_URL, {
      params: {
        action,
        ...params,
        shop: window.dynamicReview ? window.shopPreview : SHOP,
      },
    });
  },

  post: (action, params = {}) => {
    let keys;
    keys = Object.keys(params);
    keys.forEach((key) => {
      if (typeof params[key] === "object" && !Array.isArray(params[key]))
        params[key] = JSON.stringify(params[key]);
    });
    const payLoad = {
      ...params,
      action,
      shop: window.dynamicReview ? window.shopPreview : SHOP,
    };
    const formData = new FormData();

    keys = Object.keys(payLoad);
    keys.forEach((key) => {
      if (!Array.isArray(payLoad[key])) {
        formData.append([key], payLoad[key]);
      } else {
        payLoad[key].forEach((item) => {
          formData.append(`${key}[]`, item);
        });
      }
    });

    return axios.post(BASE_URL, formData);
  },

  postRelated: (action, params = {}) => {
    let keys;
    keys = Object.keys(params);
    keys.forEach((key) => {
      if (typeof params[key] === "object" && !Array.isArray(params[key]))
        params[key] = JSON.stringify(params[key]);
    });
    const payLoad = {
      ...params,
      action,
      shop: window.dynamicReview ? window.shopPreview : SHOP,
    };
    const formData = new FormData();

    for (const [key, param] of Object.entries(params)) {
      if (key === "settings") {
        for (const [key1, param1] of Object.entries(JSON.parse(param))) {
          formData.append(`settings[${key1}]`, param1);
        }
      } else {
      }
    }

    keys.forEach((key) => {
      if (key !== "settings") {
        if (!Array.isArray(payLoad[key])) {
          formData.append([key], payLoad[key]);
        } else {
          payLoad[key].forEach((item) => {
            formData.append(`${key}[]`, item);
          });
        }
      }
    });

    return axios.post(RELATED_URL, formData);
  },

  postCoreServices: (
    endpoint,
    params = {},
    headers = { Authorization: "Bearer Awi2Fvf1cGghC6FcGVKNq1G8GB87Y0Lc" }
  ) => {
    const url = `${CORE_SERVICE_URL}/api/${endpoint}`;
    params.client_id = "tracking_page";
    return axios.post(url, params, { headers: headers });
  },
};

export default apiService;
